import { Injectable } from '@angular/core';
import { fromEvent } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class KeyboardShortcutService {

  private shortcuts = new Map<string, () => void>();
  private prefix: string | null = null;
  private prefixTime = 0;

  constructor() {
    fromEvent<KeyboardEvent>(document, 'keydown')
      .subscribe(e => this.handle(e));
  }

  register(combo: string, action: () => void) {
    this.shortcuts.set(combo.toLowerCase(), action);
  }

  unregister(combo: string) {
    this.shortcuts.delete(combo.toLowerCase());
  }

  private handle(event: KeyboardEvent) {
    const tag = (event.target as HTMLElement)?.tagName;
    if (['INPUT', 'TEXTAREA'].includes(tag)) return;

    const now = Date.now();
    const key = event.key.toLowerCase();

    if (event.ctrlKey && key === 'k') {
      this.prefix = 'ctrl+k';
      this.prefixTime = now;
      event.preventDefault();
      return;
    }

    if (this.prefix && now - this.prefixTime < 1000) {
      const combo = `${this.prefix} ${key}`;
      const action = this.shortcuts.get(combo);
      if (action) {
        event.preventDefault();
        action();
      }
      this.prefix = null;
      return;
    }

    const keys = [];
    if (event.ctrlKey) keys.push('ctrl');
    if (event.shiftKey) keys.push('shift');
    if (event.altKey) keys.push('alt');
    keys.push(key);

    const combo = keys.join('+');
    const action = this.shortcuts.get(combo);
    if (action) {
      event.preventDefault();
      action();
    }
  }
}
